export default __webpack_public_path__ + "static/media/gym.ccb198ec.svg";